export default __webpack_public_path__ + "static/media/sidebar-4.6a45be60.jpg";